module.exports = "https://la-static.vkplay.ru/promo/newstart/img/blades.a6486fc2.png";